import { useMemo } from 'react'
import { useCountdown } from '../hooks/useCountdown'
import { clockFrom } from '../lib/clock'
import { formatRemaining } from '../lib/format'

interface Props {
  /** Server time of the deadline and the server's clock when it was sent. */
  deadlineAt: number
  serverNow: number
  /** "New dungeon in", "Code expires in"… */
  label: string
  className?: string
}

/** "New dungeon in 2h 5m", ticking against the server's clock. */
export function ResetCountdown({ deadlineAt, serverNow, label, className = '' }: Props) {
  const clock = useMemo(() => clockFrom(serverNow), [serverNow])
  const remaining = useCountdown(deadlineAt, clock)
  if (remaining === null) return null
  return (
    <p className={className}>
      {label} {formatRemaining(remaining)}
    </p>
  )
}
